import ShippingPackage from '../../src/legacy/ShippingPackage.tsx';
export default ShippingPackage;
